import { Expose, Transform } from 'class-transformer';
import { DrupalIdentifier, DrupalNode } from '@nx-icilalune/drupal-types';

export class Profile extends DrupalNode {
  public static readonly type = 'node--profile';

  @Transform(({ obj }) => {
    return obj?.attributes?.title;
  })
  @Expose()
  name!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.phone_number;
  })
  @Expose()
  phone!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.email;
  })
  @Expose()
  email!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.twitter?.uri;
  })
  @Expose()
  twitter!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.twitter?.title;
  })
  @Expose()
  twitterLabel!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.linkedin?.uri;
  })
  @Expose()
  linkedIn!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.linkedin?.title;
  })
  @Expose()
  linkedinLabel!: string;

  @Transform(({ obj }) => {
    return obj?.relationships?.photo_id?.data || undefined;
  })
  @Expose()
  photoID!: DrupalIdentifier | undefined;
}
